import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, namespaces } from '@paquery-team/lib-paquery-language';

i18next.use(initReactI18next).init({
  lng: 'es',
  fallbackLng: 'es',
  ns: namespaces,
  resources,
});

export default i18next;
